import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ToastService } from 'ng-uikit-pro-standard';
import { AuditoriaService } from 'src/app/services/auditoria.service';
import { auditoria } from 'src/app/shared/object/auditoria.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { SecurityService } from 'src/app/shared/services/security.service';

export interface AuditoriaInput {
  codigoEntidad: number, // RUT DEL CLIENTE O CODIGO DEL PRODUCTO
  entidad: string, // PRODUCTO O CLIENTE
}
interface InputParams {
  codigoEntidad: number,
  rutEmpresa: number,
}

@Component({
  selector: 'app-lista-auditoria',
  templateUrl: './lista-auditoria.component.html',
  styleUrls: ['./lista-auditoria.component.scss']
})
export class ListaAuditoriaComponent implements OnInit {
  @Input() auditoria: AuditoriaInput;
  loading: boolean;
  rutEmpresa: number;
  private log: any;

  listAuditoria: any[];
  cabecerasTabla: string[];
  // groupAuditoria: any[];
  
  listaCodigoEventoAgrega: number[];

  constructor(
    private auditoriaService: AuditoriaService,
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private toastService: ToastService
  ) {
    this.log = this.clog.log('MANTENEDOR-CLIENTES/AUDITORIA');
    this.loading = false;
    this.listAuditoria = [];
    this.rutEmpresa = this.accesolocalstorage.getRutEmpresa();
    this.listaCodigoEventoAgrega = [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21];
  }

  ngOnInit() {
    
  }

  // SE DISPARA CUANDO SE CAMBIA EL VALOR DE "auditoria"
  ngOnChanges(changes: SimpleChanges) {
    if (changes.auditoria && changes.auditoria.currentValue) {
      this.loading = true;
      this.handleAuditoria();
    }
  }

  isEventoAgregar(evento_auditoria_codigo: number): boolean {
    return this.listaCodigoEventoAgrega.some(x => x === evento_auditoria_codigo)
  }

  handleAuditoria(){
    this.cabecerasTabla = [
      'Fecha',
      'Hora',
      'Evento',
      'Valor Antiguo',
      'Valor Nuevo',
      'Usuario',
    ]
    const entidad: InputParams = {
      codigoEntidad: this.auditoria.codigoEntidad,
      rutEmpresa: this.rutEmpresa,
    };
    
    this.log('auditoria', this.auditoria);

    switch (this.auditoria.entidad) {
      case "CLIENTE":
        this.VerAuditoriaCliente(entidad);
        break;
      case "PRODUCTO":
        this.VerAuditoriaProducto(entidad);
        break;
      case "DESCUENTO ESPECIAL":
        this.VerAuditoriaDescuentoEspcial(entidad);
        break;
      case "DESCUENTO MAXIMO":
        this.VerAuditoriaDescuentoMaximo(entidad);
        break;
      default:
        break;
    }
  }
  VerAuditoriaCliente(entidad: InputParams) {
    const inputParams = {
      entidad,
      paginaActual: 1,
      cantidadRegistrosPorPagina: -1
    }
    this.auditoriaService.ObtenerAuditoriaCliente(inputParams, ({respuesta, mensajes}) => {
      this.procesarListaAuditoria(respuesta, mensajes);
    });
  }
  VerAuditoriaProducto(entidad: InputParams) {
    const inputParams = {
      entidad,
      paginaActual: 1,
      cantidadRegistrosPorPagina: -1
    }
    this.auditoriaService.ObtenerAuditoriaProducto(inputParams, ({respuesta, mensajes}) => {
      this.procesarListaAuditoria(respuesta, mensajes);
    })
  }
  VerAuditoriaDescuentoEspcial(entidad: InputParams) {
    this.agregarColumnaCabecera('SKU', 'Hora');
    const inputParams = {
      entidad,
      paginaActual: 1,
      cantidadRegistrosPorPagina: -1
    }
    this.auditoriaService.ObtenerAuditoriaDescuentosEspecial(inputParams, ({respuesta, mensajes}) => {
      this.procesarListaAuditoria(respuesta, mensajes);
    });
  }
  VerAuditoriaDescuentoMaximo(entidad: InputParams) {
    this.agregarColumnaCabecera('SKU', 'Hora');
    const inputParams = {
      entidad,
      paginaActual: 1,
      cantidadRegistrosPorPagina: -1,
    }
    this.auditoriaService.ObtenerAuditoriaDescuentosMaximos(inputParams, ({respuesta, mensajes}) => {
      this.procesarListaAuditoria(respuesta, mensajes);
    })
  }
  // AGREGAR COLUMNA A LA CABECERA DE LA TABLA
  agregarColumnaCabecera(nombreColumna: string, columnaAfter: string) {
    const index = this.cabecerasTabla.indexOf(columnaAfter);
    this.cabecerasTabla.splice(index + 1, 0, nombreColumna);
  }

  private procesarListaAuditoria(respuesta: any, mensajes: any) {
    if (respuesta.registros) {
      this.listAuditoria = respuesta.registros.map(x => {
        x.fecha = new Date(x.fecha);
        return x;
      });
    }
    console.log(this.listAuditoria);
    // const grouped = this.listAuditoria.reduce((grouped, auditoria) => {
    //   const fecha = auditoria.fecha.toLocaleDateString();
    //   if (!grouped[fecha]) {
    //     grouped[fecha] = [];
    //   }
    //   grouped[fecha].push(auditoria);
    //   return grouped;
    // }, {});

    // this.groupAuditoria = Object.keys(grouped).map(fecha => {
    //   return {
    //     fecha,
    //     auditorias: grouped[fecha]
    //   }
    // });

    if (mensajes.length) {
      this.log('mensajes', mensajes);
    }
    this.loading = false;
  }
}
